import { memo, useMemo } from 'react';

import { Image } from 'antd';
import cn from 'classnames';

import { THEME } from '@/shared/constants/theme';
import { useTheme } from '@/shared/lib/hooks';

import DarkHeadLogoImage from '@/shared/assets/images/algotech-head-black.png';
import WhiteHeadLogoImage from '@/shared/assets/images/algotech-head-white.png';
import DarkTextLogoImage from '@/shared/assets/images/algotech-text-black.png';
import WhiteTextLogoImage from '@/shared/assets/images/algotech-text-white.png';

import cls from './collapsed-logo.module.css';

interface CollapsedLogoProps {
    isCollapsed: boolean;
}

export const CollapsedLogo = memo((props: CollapsedLogoProps) => {
    const { isCollapsed } = props;

    const [theme] = useTheme();

    const headImageSource = useMemo(
        () => (theme === THEME.light ? DarkHeadLogoImage : WhiteHeadLogoImage),
        [theme],
    );

    const textImageSource = useMemo(
        () => (theme === THEME.light ? DarkTextLogoImage : WhiteTextLogoImage),
        [theme],
    );

    return (
        <div className={cls.root}>
            <Image
                className={cls.logo}
                preview={false}
                src={headImageSource}
            />
            <Image
                className={cn(cls.logo, cls.right, {
                    [cls.collapsed]: isCollapsed,
                })}
                preview={false}
                src={textImageSource}
            />
        </div>
    );
});

CollapsedLogo.displayName = 'CollapsedLogo';
